declare const config: { DISCOUNT_TEXT: string; DISCOUNT: string };

export default function useConfigDiscount() {
  const DISCOUNT_TEXT = (config && config.DISCOUNT_TEXT) || "";
  const DISCOUNT = (config && config.DISCOUNT) || "";

  return {
    DISCOUNT_TEXT,
    DISCOUNT
  };
}
